import * as z from "zod";

export const updateNativeAccountsSettings = {
  name: "updateNativeAccountsSettings" as const,
  input: z.object({
    overrideAccountLinks: z.boolean(),
    redirectFromAccountsPages: z.boolean(),
  }),
  output: z.null(),
};
